import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebaseConfig";

const CLIENT_ERRORS_COLLECTION = "client_errors";

export interface ClientErrorPayload {
  incidentId: string;
  message: string;
  stack: string;
  componentStack: string;
  currentUrl: string;
  userAgent: string;
}

export async function submitClientError(payload: ClientErrorPayload): Promise<void> {
  await addDoc(collection(db, CLIENT_ERRORS_COLLECTION), {
    ...payload,
    createdAt: Timestamp.now(),
  });
}
